import * as Y from 'yjs';

import { genRandId } from '@/utils/core.utils';
import { ObjectFit } from '@/widgets/Image/types';

export type DefaultAnswerConfig = { hasText?: boolean; hasImage?: boolean; hasAudio?: boolean; hasVideo?: boolean };

export const generateDefaultAnswer = (config: DefaultAnswerConfig) => {
  const { hasAudio, hasImage, hasText, hasVideo } = config;
  const map = new Y.Map([['id', genRandId()]]);

  if (hasText) {
    map.set('text', new Y.Map([['fragment', new Y.XmlFragment()]]));
  }

  if (hasImage) {
    map.set(
      'image',
      new Y.Map([
        ['src', ''],
        ['alt', ''],
        ['mobileSrc', ''],
        ['objectFit', ObjectFit.Contain],
        ['mobileObjectFit', ObjectFit.Contain]
        // isDecorative property remains undefined, since it's not used for the nested image
      ])
    );
  }

  if (hasAudio) {
    map.set(
      'audio',
      new Y.Map([
        ['src', ''],
        ['title', '']
      ])
    );
  }

  if (hasVideo) {
    map.set('video', new Y.Map());
  }

  return map;
};
